"use client";
import { useState, useEffect } from "react";

const SESSION_KEY = "temp_auth_verified";

/**
 * Temporary authentication modal - REMOVE THIS AFTER STAGING REVIEW
 * To remove: Delete this file and remove usage from app/(main)/layout.tsx
 */
const TemporaryAuthModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    // Check if already authenticated in this session
    if (typeof window !== "undefined") {
      const isVerified = sessionStorage.getItem(SESSION_KEY);
      if (isVerified === "true") {
        return;
      }

      // Show modal after 3 seconds
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    const expectedUsername = process.env.NEXT_PUBLIC_UNAME;
    const expectedPassword = process.env.NEXT_PUBLIC_PASS;

    if (username === expectedUsername && password === expectedPassword) {
      sessionStorage.setItem(SESSION_KEY, "true");
      setIsOpen(false);
    } else {
      setError("Invalid username or password");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Backdrop - no click to close */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4 z-10">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Authentication Required
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          Please enter your credentials to continue.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="temp-username"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Username
            </label>
            <input
              id="temp-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              placeholder="Enter username"
              autoComplete="off"
            />
          </div>

          <div>
            <label
              htmlFor="temp-password"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Password
            </label>
            <input
              id="temp-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              placeholder="Enter password"
              autoComplete="off"
            />
          </div>

          {error && (
            <p className="text-sm text-red-600 bg-red-50 px-3 py-2 rounded-md">
              {error}
            </p>
          )}

          <button
            type="submit"
            className="w-full bg-primary text-white py-2 px-4 rounded-md hover:bg-primary/90 transition-colors font-medium"
          >
            Continue
          </button>
        </form>
      </div>
    </div>
  );
};

export default TemporaryAuthModal;
